"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgUnlink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var SvgUnlink = function SvgUnlink(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "title", "desc", "titleId", "descId"]);
  return _react["default"].createElement(_Svg["default"], (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: "currentcolor"
  }, props), !!title && _react["default"].createElement("title", {
    id: titleId
  }, title), !!desc && _react["default"].createElement("desc", {
    id: descId
  }, desc), _react["default"].createElement("g", {
    className: "unlink_svg__nc-icon-wrapper"
  }, _react["default"].createElement("path", {
    "data-color": "color-2",
    d: "M9.172 13.414l-1.879 1.879a1 1 0 101.414 1.414l1.879-1.879z"
  }), _react["default"].createElement("path", {
    d: "M12.672 16.914L9.74 19.846a3.95 3.95 0 01-5.586-5.586l2.932-2.932-1.415-1.414-2.933 2.933a5.949 5.949 0 008.414 8.413l2.933-2.933z"
  }), _react["default"].createElement("path", {
    "data-color": "color-2",
    d: "M13.414 9.172l1.879-1.879a1 1 0 111.414 1.414l-1.879 1.879z"
  }), _react["default"].createElement("path", {
    d: "M16.914 12.672l2.932-2.932a3.95 3.95 0 00-5.586-5.586l-2.932 2.932-1.414-1.415 2.933-2.933a5.949 5.949 0 018.413 8.414l-2.933 2.933z"
  }), _react["default"].createElement("path", {
    "data-color": "color-2",
    d: "M1.585 3L3 1.586 22.414 21 21 22.414z"
  })));
};

exports.SvgUnlink = SvgUnlink;
SvgUnlink.isIcon = true;
SvgUnlink.defaultProps = {
  size: 24,
  'aria-hidden': 'true',
  focusable: 'false'
};
var _default = SvgUnlink;
exports["default"] = _default;